<ion-header>
  <ion-toolbar>
    <ion-title>Classification Inferenced History</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
  
<ion-content class="no-hover-page" [fullscreen]="true" >
  <div class="scroll-container" style="overflow-x: auto; width: 100%;">
    <ng-container>
        <ion-grid style="min-width: 1200px;">
          <!-- Table Header Row -->
          <ion-row class="table-header">
            <ion-col size="1"><strong>Index</strong></ion-col>
            <ion-col size="2"><strong>Question</strong></ion-col>
            <ion-col size="2"><strong>User Response</strong></ion-col>
            <ion-col size="2"><strong>Model Response</strong></ion-col>
            <ion-col size="2"><strong>Correct Answer</strong></ion-col>
            <ion-col size="1"><strong>User</strong></ion-col>
            <ion-col size="1"><strong>Actions</strong></ion-col>
            <ion-col size="1"><strong>Model Name</strong></ion-col>
          </ion-row>
        
          <!-- Data Rows -->
          <ion-row *ngFor="let item of historyData; let i = index" class="table-row">
            <ion-col size="1">{{ i + 1 }}</ion-col>
        
          

            <ion-col size="2">
              <div>
                <p>{{ item.question }}</p>
              </div>
            </ion-col>
            <ion-col size="2">
              <div>
                <p>{{ item.user_answer }}</p>
              </div>
            </ion-col>
            <ion-col size="2">
              <div>
                <p>{{ item.predicted_answer }}</p>
                <!-- <p>({{ item.confidence_score * 100 | number:'1.2-2' }}%)</p> -->
                <p>{{ item.predicted_answer?.trim() !== '' ? (item.confidence_score * 100 | number:'1.2-2') + '%' : ' ' }}</p>


              </div>
            </ion-col>
            <ion-col size="2">
              <div>
                <p>{{ item.corrected_answer }}</p>
              </div>
            </ion-col>
            <ion-col size="1">
              <p>{{ item.user }}</p>
            </ion-col>
            
            
            
        
            <ion-col size="1">
              <div class="tooltip-wrapper">
                <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="deleteData(item)">
                  <ion-icon slot="icon-only" name="trash-outline" ></ion-icon>
                </ion-button>
                <span class="custom-tooltip">Delete Data</span>
              </div>
            </ion-col>

            <ion-col size="1">
              <p>{{ item.model_name }}</p>
            </ion-col>
          </ion-row>
        
          <!-- Empty State -->
          <ion-row *ngIf="historyData.length === 0">
            <ion-col>
              <p>No history found.</p>
            </ion-col>
          </ion-row>
        </ion-grid>
        
        

    </ng-container>
  </div>
  
</ion-content>
    

  
